import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { AuthService } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChauffeurHrService {

  /**
   *
   * @param authService
   */
  constructor(private authService: AuthService, private apiService: CommonService) { }

  private readonly apiPath: string = '/api/chauffeurs';

  /**
   *
   * @param driverId
   * @param viewType
   * @returns
   */
  loadPage(driverId: string, viewType: string): Observable<IPageDataViewModel> {
    const paramData = {
      tranquilityBase: environment.tranquilityBase,
      driverId: driverId,
      viewType: viewType
    };
    return this.apiService.getData('PageCommand', 'chauffeur-hr', 'page-load', paramData, this.apiPath, true);
  }

}


/**
 *
 */
export interface IChauffeurHrPageData {
  config: {
    url: string;
    links: { title: string, url: string }[];
  }
}
